<template>
  <s-crud
    @returnObject="refresh($event)"
    no-border
    title="Mercados"
    :config="config"
    @save="save($event)"
    add
    @clearForm="clearForm()"
    edit
    restore
    @rowSelected="rowSelected($event)"
    remove
    :filter="filter"
    search-input
    ref="crud"
  >
    <template scope="props">
      <v-container style="padding-top:0px;" v-if="props.item != null" class="pb-0">
        <v-row>
          <v-col cols="12" sm="4" class="s-col-form">
            <s-text
              autofocus
              ref="Code"
              v-model="props.item.Code"
              label="Código *"
              placeholder="Ej: USA, EUR, CHN"
            />
          </v-col>
          <v-col cols="12" sm="8" class="s-col-form">
            <s-text
              v-model="props.item.Description"
              label="Descripción Mercado *"
              placeholder="Ej: Estados Unidos, Unión Europea"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-slot:SecStatus="{ row }">
      <v-chip style="margin:0px" x-small :color="row.SecStatus == 1 ? 'success' : 'error'">
        {{ row.SecStatus == 1 ? "Activo" : "Inactivo" }}
      </v-chip>
    </template>
  </s-crud>
</template>

<script>
import _sMarketsService from "@/services/Technicalassistance/MarketsService";

export default {
  name: "Markets",
  props: {
    isAdmin: { type: Boolean, default: true },
  },
  data: () => ({
    mktId: 0,
    config: {
      title: "Mercados",
      service: _sMarketsService,
      model: {
        MktID: "ID",
        Code: "string",
        Description: "string",
        SecStatus: "status",
      },
      headers: [
        { text: "ID", value: "MktID", width: "10%", align: "end", sortable: true },
        { text: "Código", value: "Code", width: "25%", sortable: true },
        { text: "Descripción", value: "Description", width: "50%", sortable: true },
        { text: "Estado", value: "SecStatus", width: "15%", align: "center", sortable: false },
      ],
    },
  }),
  computed: {
    filter() {
      return {};
    },
  },
  methods: {
    rowSelected(items) {
      if (items.length > 0) this.mktId = items[0].MktID;
      this.$emit("rowSelected", items);
    },
    refresh(item) {
      this.$emit("refresh", item);
    },
    clearForm() {
      if (this.$refs.Code) {
        this.$refs.Code.focus();
      }
    },
    save(item) {
      if (!item.Code || item.Code.trim().length === 0) {
        this.$fun.alert("Ingrese el código del mercado.", "warning");
        return;
      }
      if (!item.Description || item.Description.trim().length === 0) {
        this.$fun.alert("Ingrese la descripción del mercado.", "warning");
        return;
      }
      item.SecStatus = 1;
      item.UsrCreateID = this.$fun.getUserID();
      item.save();
    },
  },
};
</script>
